// assets/main.js
document.addEventListener("DOMContentLoaded", () => {
  /**
   * A11Y: every Material icon in this theme is decorative (text label
   * always sits next to it). Hide them from screen readers in one pass
   * so we don't have to touch every section/snippet file.
   */
  document.querySelectorAll(".material-icons-outlined").forEach((icon) => {
    if (!icon.hasAttribute("aria-hidden")) {
      icon.setAttribute("aria-hidden", "true");
    }
  });

  /**
   * HEADER MENU (open/close)
   */
  const menuToggle = document.querySelector(
    ".header .user-actions .menu-toggle"
  );
  const mobileMenu = document.querySelector(".mobile-menu");

  // Portal the mobile menu to <body> so its backdrop-filter sees the whole
  // page, not just the header's stacking context.
  if (mobileMenu && mobileMenu.parentElement !== document.body) {
    document.body.appendChild(mobileMenu);
  }

  const menuClose = mobileMenu
    ? mobileMenu.querySelector(".menu-close")
    : null;

  const toggleMenu = (show) => {
    if (!mobileMenu || !menuToggle) return;
    mobileMenu.classList.toggle("is-active", show);

    const isExpanded = mobileMenu.classList.contains("is-active");
    menuToggle.setAttribute("aria-expanded", String(isExpanded));
    mobileMenu.setAttribute("aria-hidden", String(!isExpanded));
  };

  if (menuToggle && mobileMenu && menuClose) {
    menuToggle.addEventListener("click", (e) => {
      e.preventDefault();
      toggleMenu(!mobileMenu.classList.contains("is-active"));
    });

    menuClose.addEventListener("click", (e) => {
      e.preventDefault();
      toggleMenu(false);
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") toggleMenu(false);
    });
  }

  /**
   * SEARCH (submit to Shopify search)
   * Works with the <form action="{{ routes.search_url }}" method="get"> in header.liquid
   */
  const searchForm = document.querySelector("#header .search-form");
  const searchInput = document.querySelector(
    "#header .search-form .search-input"
  );

  if (searchForm && searchInput) {
    // Optional: trim and prevent empty searches
    searchForm.addEventListener("submit", (e) => {
      const q = (searchInput.value || "").trim();
      if (!q) {
        e.preventDefault();
        searchInput.focus();
        return;
      }
      searchInput.value = q;
      // Let the browser submit normally to /search?q=...
    });
  }

  /**
   * PRODUCT PAGE THUMBNAILS (select image)
   * Expects markup like:
   * - .main-image img
   * - .thumbnails .thumb (buttons) with data-src="..."
   */
  const initializeThumbnails = (container = document) => {
    const mainImg = container.querySelector(".main-image img");
    const thumbs = Array.from(container.querySelectorAll(".thumbnails .thumb"));
    if (!mainImg || thumbs.length === 0) return;

    const setActive = (btn) => {
      const src = btn?.dataset?.src;
      if (!src) return;

      mainImg.src = src;

      thumbs.forEach((b) => {
        b.classList.remove("is-active");
        b.setAttribute("aria-pressed", "false");
      });

      btn.classList.add("is-active");
      btn.setAttribute("aria-pressed", "true");
    };

    thumbs.forEach((btn) => {
      btn.setAttribute("type", "button");
      btn.setAttribute("role", "button");
      btn.setAttribute(
        "aria-pressed",
        btn.classList.contains("is-active") ? "true" : "false"
      );

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        setActive(btn);
      });

      btn.addEventListener("keydown", (ev) => {
        if (ev.key === "Enter" || ev.key === " ") {
          ev.preventDefault();
          btn.click();
        }
      });
    });

    if (!thumbs.some((b) => b.classList.contains("is-active"))) {
      setActive(thumbs[0]);
    }
  };

  initializeThumbnails(document);

  /**
   * PRODUCT QUANTITY (+/- buttons)
   * Expects .qty-btn buttons with data-action="increase|decrease"
   * next to an input[name="quantity"] in the same .formgroup
   */
  document.querySelectorAll(".qty-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const input = btn
        .closest(".formgroup")
        ?.querySelector('input[name="quantity"]');
      if (!input) return;

      const min = parseInt(input.min, 10) || 1;
      const current = parseInt(input.value, 10) || min;
      const step = btn.dataset.action === "increase" ? 1 : -1;
      const max = parseInt(input.max, 10) || Infinity;
      input.value = Math.min(max, Math.max(min, current + step));
    });
  });
});
